import React, { useState } from 'react'
import { StepProps } from '../../../../components/_WMS/Stepper'
import { SharedStateType } from '../../types'
import { Box, TextField, Typography } from '@mui/material'
import { useStyles } from '../styles'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import PulsingIcon from '../../../../components/_WMS/_icons/PulsingIcon'

interface WaitingScreenProps extends StepProps<SharedStateType> {}

export const WaitingScreen: React.FC<WaitingScreenProps> = ({
  next,
  sharedState: { workOrderId, user, positionCode }
}) => {
  const classes = useStyles()

  const [error, setError] = useState('')

  const [confirmedPosition, setConfirmedPosition] = useState<string>('')

  const handleScanPosiiton = (
    event:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault()

    const isScannedPositionEqualToSelectedPosition =
      confirmedPosition === positionCode

    if (!isScannedPositionEqualToSelectedPosition) {
      setError(`Posición escaneada no corresponde a posición ${positionCode}`)
      return
    }

    setError('')
    next()
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Typography variant='body1'>OT {workOrderId}</Typography>
        <Typography variant='body1'>Posición {positionCode}</Typography>
      </Box>
      <Box className={classes.content}>
        <Box className={classes.buttonContainer}>
          <PulsingIcon
            IconComponent={ArrowForwardIcon}
            maxScale={5}
            duration='2s'
            initialColor='lightgrey'
            finalColor='black'
            initialOpacity={0.3}
            finalOpacity={1}
            fontSize='large'
          />
        </Box>

        <div>
          <Typography variant='body2'>
            {user?.userAlias || user?.email} dirijase a la posición{' '}
            {positionCode}...
          </Typography>
        </div>
      </Box>

      <Box className={classes.footer}>
        <form onSubmit={handleScanPosiiton}>
          <TextField
            fullWidth
            autoFocus
            variant='outlined'
            label='Escanee la posición para continuar...'
            value={confirmedPosition}
            onChange={(e) => setConfirmedPosition(e.target.value)}
            error={error.length > 0}
            helperText={error}
          />
        </form>
      </Box>
    </Box>
  )
}
